import { combineReducers } from '@reduxjs/toolkit';
import ownersReducer from './ownersSlice';
import ldTeamsReducer from './ldTeamsSlice';
import businessTeamsReducer from './businessTeamsSlice';
import processesReducer from './processesSlice';
import stagesReducer from './stagesSlice';
import programsReducer from './programsSlice';

export default combineReducers({
  owners: ownersReducer,
  ldTeams: ldTeamsReducer,
  businessTeams: businessTeamsReducer,
  processes: processesReducer,
  stages: stagesReducer,
  programs: programsReducer,
});
